import { Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { ISubscriptionExpiryTooltipProps } from "../../Types";
import { SubscriptionExpiryFooter } from "../SubscriptionExpiryFooter";

export const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#FFFFFF",
    boxShadow: theme.shadows[1],
    borderRadius: 12,
    color: "rgba(0, 0, 0, 0.87)",
    padding: 15,
  },
  arrow: {
    color: "#FFFFFF",
    fontSize: 22,
    "&:before": {
      boxShadow: theme.shadows[1],
    },
  },
}))(Tooltip);

export const SubscriptionExpiryTooltip = ({
  children,
  placement = "right",
  enableTooltip = true,
  beforeShowOffers,
  afterRenewCallback,
  isEcommPro,
  subscriptionStatus,
}: ISubscriptionExpiryTooltipProps) => {
  const _TooltipBody = () => 
    <div>
      <p className="mv0 md-text16 lh-copy fw4">
        This feature is locked as your eCommerce {isEcommPro ? "Pro" : "Essential"} subscription is expired
      </p>
      <SubscriptionExpiryFooter
        subscriptionStatus={subscriptionStatus}
        afterRenewCallback={afterRenewCallback}
        beforeShowOffers={beforeShowOffers}
      />
    </div>
  ;
  if (!enableTooltip) {
    return <>{children}</>;
  }
  return (
    <CustomTooltip arrow placement={placement} title={_TooltipBody()} interactive>
      <div>{children}</div>
    </CustomTooltip>
  );
};
